import { render, staticRenderFns } from "./RiskForm.vue?vue&type=template&id=0933e3a6&scoped=true&"
import script from "./RiskForm.vue?vue&type=script&lang=js&"
export * from "./RiskForm.vue?vue&type=script&lang=js&"
import style0 from "./RiskForm.vue?vue&type=style&index=0&id=0933e3a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0933e3a6",
  null
  
)

export default component.exports